export default __webpack_public_path__ + "static/media/leaderboard-icon.4af59ba6.svg";